// Totals, map cards and modal ranges of the Overview
module.exports = {
  ranges: {
    today: {chip: "Hoje", text: "hoje"},
    yesterday: {chip: "Ontem", text: "ontem"},
    last7: {chip: "7 dias", text: "em 7 dias"},
    last30: {chip: "30 dias", text: "em 30 dias"},
    last90: {chip: "90 dias", text: "em 90 dias"},
    year: {chip: "1 ano", text: "em 1 ano"},
  },
  totals: {
    open: "Ver detalhes",
    modalSubtitle: "Cada barra tem a mesma duração do período selecionado.",
    users: {
      label: "Total de usuários",
      noun: "novos usuários",
      hint: "Todos os cadastrados, não só os ativos",
      modalTitle: "Novos usuários: este período vs. anteriores",
      info: "Contas criadas desde o início.\nFonte: Firebase (contadores de registos).",
    },
    voxpoints: {
      label: "Total de VoxPoints",
      noun: "novos VoxPoints",
      hint: "Todos os VoxPoints cadastrados",
      modalTitle: "Novos VoxPoints: este período vs. anteriores",
      info: "VoxPoints criados desde o início, ativos ou não.\nFonte: Firebase (VoxPoints).",
    },
    events: {
      label: "Total de eventos",
      noun: "novos eventos",
      hint: "Todos os eventos já feitos até hoje",
      modalTitle: "Novos eventos: este período vs. anteriores",
      info: "Eventos criados desde o início, incluindo os apagados.\nFonte: Firebase (contadores de eventos).",
    },
  },
  mapCards: {
    stats: {continents: "Continentes", countries: "Países", cities: "Cidades"},
    events: {title: "Mapa de Eventos", total: "Total de eventos no mapa", tabs: {total: "Total", active: "Ativos"}},
    users: {title: "Mapa de Usuários", total: "Total de usuários no mapa", tabs: {total: "Total"}},
    voxpoints: {title: "Mapa de VoxPoints", total: "Total de VoxPoints no mapa", tabs: {total: "Total"}},
  },
};
